import { sendToLogServer } from "../core/service/BusinessLogicService"
import { apigateway } from "../intances/apigateway"
import { getUserToken } from "./authorization"

export const patchOrder = ({ tunnelData, values }) => {
  const headers = {
    Authorization: `Bearer ${getUserToken()}`,
    Accept: "*/*"
  }
  return apigateway(tunnelData)
    .post(`/middle-business-service/api/v3/order/${tunnelData.opl}`, values, { headers: headers })
    .then((res) => {
      return {
        success: true,
        values: values
      }
    })
    .catch((error) => {
      sendToLogServer(
        "ERROR",
        "There was an error in the v3 /order/opl endpoint" + tunnelData.opl + " : " + JSON.stringify(error)
      )
      console.error(error)
      return false
    })
}
